import React, { useState } from 'react';
import TooltipIcon from 'images/Icon_Tooltip.png';

type Props = {
  text: string;
};

const Tooltip = ({ text }: Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleHover = () => setIsOpen(!isOpen);

  return (
    <span className="Tooltip">
      <img
        onMouseEnter={handleHover}
        onMouseLeave={handleHover}
        className="TooltipIcon"
        src={TooltipIcon}
        alt="Tooltip"
      />
      {isOpen && <span className="TooltipText">{text}</span>}
    </span>
  );
};

export default Tooltip;
